import { render, staticRenderFns } from "./projectItem.vue?vue&type=template&id=66a1d2ea&"
import script from "./projectItem.vue?vue&type=script&lang=js&"
export * from "./projectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports